import { createAction, props } from "@ngrx/store";
import { IProfessionalTransfersReport } from "src/app/shared/interfaces/professional-transfers-report/iprofessionaltransfersreport";

enum ProfessionalTransfersReportActionType {
    LOAD_PROFESSIONAL_TRANSFERS_REPORT = '[professional transfers] load professional transfers report from api',
    LOAD_PROFESSIONAL_TRANSFERS_REPORT_SUCCESS = '[professional transfers] load professional transfers report from api return success',
}

const loadProfessionalTransfersReport = createAction(
    ProfessionalTransfersReportActionType.LOAD_PROFESSIONAL_TRANSFERS_REPORT
);

const loadProfessionalTransfersReportSuccess = createAction(
    ProfessionalTransfersReportActionType.LOAD_PROFESSIONAL_TRANSFERS_REPORT_SUCCESS,
    props<{ professional_transfers_report: IProfessionalTransfersReport }>()
);

export const ProfessionalTransfersReportActions = {
    loadProfessionalTransfersReport,
    loadProfessionalTransfersReportSuccess
}
